module.exports = __webpack_public_path__ + "media/images/athletes/882-57d54b525c98cb7b0e76e31f52491b83.png";